import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ToastContainer';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import EmailVerification from './pages/EmailVerification';
import Dashboard from './pages/Dashboard';
import Connections from './pages/Connections';
import Company from './pages/Company';
import Admin from './pages/Admin';
import Downloads from './pages/Downloads';
import Companies from './pages/admin/Companies';
import Servers from './pages/admin/Servers';
import Settings from './pages/admin/Settings';
import Logs from './pages/admin/Logs';
import AdminDownloads from './pages/AdminDownloads';
import AdminLicenses from './pages/AdminLicenses';
import Tickets from './pages/Tickets';
import AdminTickets from './pages/AdminTickets';
import Notifications from './pages/Notifications';
import Profile from './pages/Profile';
import Upgrade from './pages/Upgrade';
import Checkout from './pages/Checkout';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Docs from './pages/Docs';
import About from './pages/About';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import Help from './pages/Help';
import Status from './pages/Status';
import Updates from './pages/Updates';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/help" element={<Help />} />
          <Route path="/status" element={<Status />} />
          <Route path="/updates" element={<Updates />} />
          <Route 
            path="/verify-email" 
            element={
              <ProtectedRoute>
                <EmailVerification />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="connections" element={<Connections />} />
            <Route path="company" element={<Company />} />
            <Route path="downloads" element={<Downloads />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="profile" element={<Profile />} />
            <Route path="upgrade" element={<Upgrade />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="companies" element={<Companies />} />
            <Route path="servers" element={<Servers />} />
            <Route path="settings" element={<Settings />} />
            <Route path="logs" element={<Logs />} />
            <Route path="downloads" element={<AdminDownloads />} />
            <Route path="licenses" element={<AdminLicenses />} />
            <Route path="tickets" element={<AdminTickets />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
